import React, { useState } from 'react';
import { useTheme } from '../contexts/ThemeContext';

const Header = () => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const { isDark, toggleTheme } = useTheme();

    return (
        <header className="bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-800 sticky top-0 z-50">
            <div className="px-4 sm:px-6 lg:px-8 py-1 flex items-center justify-between">
                {/* Logo */}
                <div className="flex items-center gap-2">
                    <a href="/">
                        <img
                            src={isDark ? '/logo_dark.png' : '/logo_light.png'}
                            alt="RewriteKing"
                            className="h-6 rounded"
                        />
                    </a>
                </div>

                <div className="hidden lg:flex items-center gap-4">
                    {/* <button className="text-sm text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-gray-100">Chrome Extension</button> */}
                    {/* Dark Mode Toggle */}
                    <button
                        onClick={toggleTheme}
                        className="p-2 rounded-lg text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
                        aria-label="Toggle dark mode"
                    >
                        {isDark ? (
                            <i className="fas fa-sun text-xl"></i>
                        ) : (
                            <i className="fas fa-moon text-xl"></i>
                        )}
                    </button>
                </div>

                {/* Mobile Menu Button and Dark Mode Toggle */}
                <div className="flex items-center gap-2 lg:hidden">
                    <button
                        onClick={toggleTheme}
                        className="p-2 rounded-lg text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
                        aria-label="Toggle dark mode"
                    >
                        {isDark ? (
                            <i className="fas fa-sun text-xl"></i>
                        ) : (
                            <i className="fas fa-moon text-xl"></i>
                        )}
                    </button>
                    <button
                        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                        className="p-2 rounded-lg text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
                        aria-label="Toggle menu">
                        <i className={`fas ${mobileMenuOpen ? 'fa-times' : 'fa-bars'} text-xl`}></i>
                    </button>
                </div>
            </div>

            {/* Mobile Menu */}
            {mobileMenuOpen && (
                <div className="lg:hidden border-t border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900">
                    <div className="px-4 py-4 space-y-3">
                        {/* <button className="block w-full text-left text-primary-600 dark:text-primary-400 font-medium py-2 border-b-2 border-primary-600 dark:border-primary-400">
                            Text
                        </button>
                        <button className="block w-full text-left text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-gray-100 py-2">
                            History
                        </button>
                        <button className="block w-full text-left text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-gray-100 py-2">
                            Export
                        </button>
                        <button className="block w-full text-left text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-gray-100 py-2">
                            API
                        </button> */}

                        {/* <div className="pt-3 border-t border-gray-200 dark:border-gray-800 mt-3 space-y-2">
                            <button className="block w-full text-left text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-gray-100 py-2">
                                Features
                            </button>
                            <button className="block w-full text-left text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-gray-100 py-2">
                                Legal
                            </button>
                            <button className="block w-full text-left text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-gray-100 py-2">
                                Desktop
                            </button>
                            <button className="block w-full text-left text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-gray-100 py-2">
                                Pricing
                            </button>
                        </div> */}

                        {/* <div className="pt-3 border-t border-gray-200 dark:border-gray-800 mt-3 space-y-2">
                            <button className="w-full text-center text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-gray-100 py-2">
                                Sign in
                            </button>
                            <button className="w-full bg-primary-600 hover:bg-primary-700 text-white py-2 rounded-lg font-medium">
                                Try Pro
                            </button>
                        </div> */}
                    </div>
                </div>
            )}
        </header>
    );
};

export default Header;



